/**
 * 打开新视图
 * 适用于卡牛，随手记
 */
define('util/client-newView',[
  'util/client-bridge',
  'util/host'
], function(clientBridge, host) {
    return function(url) {
        var _url = host(url);
        if (CLIENT_DATA.client === 'ssj') {
            clientBridge.call(clientBridge.uriSuishouji('requestMarket', {
                url: _url
            }));
        } else if (CLIENT_DATA.client === 'kn') {
            clientBridge.call('cardniu://app/openNewWindow?url=' + encodeURIComponent(_url));
        } else {
            window.location.href = _url;
        }
    };
});

